import { useState } from 'react'
import { Button, Typography, Box } from '@mui/material'
import { colorPrimitives } from 'components/Theme'
import { type ContestEntryBonusSchedule, type Sweepstake } from 'types/api'
import { SettingsModal } from './SettingsModal'
import { EntryMultiplierSection } from './EntryMultiplierSection'
import { addMissingDays } from './SweepstakeEntryMultiplierDetailsUtils'

interface SweepstakeEntryMultiplierSectionProps {
  sweepstake: Sweepstake
}

export const SweepstakeEntryMultiplierSection = ({
  sweepstake,
}: SweepstakeEntryMultiplierSectionProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const toggleModalVisibility = () => {
    setIsModalVisible(!isModalVisible)
  }
  const daysToDisplay: ContestEntryBonusSchedule[] = addMissingDays(
    sweepstake?.contestEntryBonusSchedules ?? []
  )

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          pr: { xs: '0px', sm: '16px' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: '16px',
            alignItems: { xs: 'flex-start', sm: 'center' },
          }}
        >
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{ whiteSpace: 'nowrap' }}
          >
            Grant Additional Sweepstake Entries
          </Typography>
        </Box>
        <Button
          variant="text"
          onClick={toggleModalVisibility}
          sx={{
            maxWidth: { xs: '32px', sm: 'auto' },
            minWidth: 'auto',
            maxHeight: { xs: '20px', sm: 'auto' },
          }}
        >
          <Typography
            color={colorPrimitives.redGaming}
            variant="body-1"
            fontWeight="bold"
          >
            Edit
          </Typography>
        </Button>
      </Box>
      <EntryMultiplierSection sweepstake={sweepstake} />
      <SettingsModal
        sweepstake={sweepstake}
        isModalVisible={isModalVisible}
        toggleModalVisibility={toggleModalVisibility}
        daysToDisplay={daysToDisplay ?? []}
      />
    </Box>
  )
}
